import React, { useState, useEffect, useRef } from 'react';
import { theme, fontStack } from '../theme';

/* ── Intersection Observer Hook ── */
export function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); obs.unobserve(el); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

/* ── Animated Section Wrapper ── */
export function FadeIn({ children, delay = 0, style = {} }) {
  const [ref, inView] = useInView(0.1);
  return (
    <div
      ref={ref}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(40px)",
        transition: `opacity 0.8s ease ${delay}s, transform 0.8s ease ${delay}s`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

/* ── Cross SVG Icon ── */
export function CrossIcon({ size = 24, color = theme.gold }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="10" y="2" width="4" height="20" rx="1" fill={color} />
      <rect x="4" y="8" width="16" height="4" rx="1" fill={color} />
    </svg>
  );
}

/* ── Decorative Divider ── */
export function Divider({ width = 80 }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, justifyContent: "center", margin: "24px 0" }}>
      <div style={{ width, height: 1, background: `linear-gradient(90deg, transparent, ${theme.gold}, transparent)` }} />
      <CrossIcon size={16} />
      <div style={{ width, height: 1, background: `linear-gradient(90deg, transparent, ${theme.gold}, transparent)` }} />
    </div>
  );
}
